export function isLegacyBlueprintSpec(spec) {
    return 'blueprintRef' in spec;
}
export function isBlueprintSpec(spec) {
    return 'blueprint' in spec;
}
export function isFlowSpec(spec) {
    return 'trigger' in spec;
}
export function isSimpleTriggerCallSite(trigger) {
    return typeof trigger === 'string';
}
export function isComplexTriggerCallSite(trigger) {
    return typeof trigger !== 'string';
}
//# sourceMappingURL=guards.js.map